module.exports = __webpack_public_path__ + "static/media/img-get-tower-cdh.1a2d3972.png";